<template>
  <v-dialog v-model="dialog" width="800px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="materialKeyword"
              :label="$t('Material.materialNameKeyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategory v-model="categorySelected" />
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="materialItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              materials.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.Description="{ item }">
          <span
            v-if="item.standard_name && item.standard_name.length > 12"
            :title="item.standard_name"
            style="cursor: pointer"
          >
            {{ item.Description }}
          </span>
          <span v-else>
            {{ item.Description }}
          </span>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Materials from "@/api/materials";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";

export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    changed: Array,
    materialIds: Array,
    options: Object,
    disabledItems: Array,
  },

  components: {
    SearcherKeyword,
    SearcherMaterialCategory,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "category_name",
        },
        {
          text: i18n.t("Material.Fields.material_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    materialItems() {
      //前端搜索
      return this.materials.filter(
        (item) =>
          ((this.categorySelected &&
            item.category_code.indexOf(this.categorySelected.code) > -1) ||
            !this.categorySelected) &&
          ((this.materialKeyword &&
            item.Description.indexOf(this.materialKeyword) > -1) ||
            !this.materialKeyword)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    materialKeyword: "",
    categorySelected: null,
    itemsPerPageOptions: 10,
    materialIdsChoosed: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    fetchTimestamp: 0, //第一次获取商品列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    //获取material列表
    getMaterialsFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.materials = this.materials.map((material) => {
          material.Description = i18n.t(
            "Material.materialNameWithCodeAndStandard",
            [
              material.material_code,
              material.material_name,
              material.standard_name && material.standard_name.length > 12
                ? material.standard_name.slice(0, 12) + "......"
                : material.standard_name,
            ]
          );

          if (
            this.materialIdsChoosed.indexOf(material.material_id) > -1 &&
            (!material.choose || !material.disabled)
          ) {
            material = Object.assign({}, material, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.materialIdsChoosed.indexOf(material.material_id) == -1 &&
            (material.choose == 1 || material.disabled)
          ) {
            if (material.choose == 1) {
              material.choose = 0;
            }
            if (material.disabled) {
              material.disabled = false;
            }
          }

          return material;
        });

        return;
      }

      Materials.fetch({}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials.map((material) => {
              material.Description = i18n.t(
                "Material.materialNameWithCodeAndStandard",
                [
                  material.material_code,
                  material.material_name,
                  material.standard_name && material.standard_name.length > 12
                    ? material.standard_name.slice(0, 12) + "......"
                    : material.standard_name,
                ]
              );
              //默认勾选
              if (this.materialIdsChoosed.indexOf(material.material_id) > -1) {
                material = Object.assign({}, material, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (material.choose == 1 || !material.choose) {
                  material.choose = 0;
                }
                if (material.disabled) {
                  material.disabled = false;
                }
              }

              return material;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          if (this.disabledItems && this.disabledItems.length) {
            this.materialIdsChoosed = this.disabledItems.map((item) => {
              return item.material_id - 0;
            });
          }
          this.choosedLength = this.materialIdsChoosed.length;
          this.getMaterialsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.materialKeyword = "";
          this.categorySelected = null;
          this.chooseAll = false;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.materials = this.materials.map(
          function (e) {
            var item = this.materialItems.find(
              (m) => m.material_id == e.material_id
            );
            if (item) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    materials: {
      deep: true,
      handler() {
        //整理新增商品
        this.materials.forEach((material) => {
          if (
            material.choose &&
            !this.materialIdsChoosed.includes(material.material_id) &&
            !this.newChoosedArr.find(
              (new_choosed) => new_choosed.material_id == material.material_id
            )
          ) {
            this.newChoosedArr.push(material);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !material.choose &&
            this.newChoosedArr.find(
              (new_choosed) => new_choosed.material_id == material.material_id
            )
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) => new_choosed.material_id == material.material_id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
  },
};
</script>